import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useParams } from "react-router-dom";

import BottomNav from "../components/bottom";
import Float from "../components/side_button";
import Floattwo from "../components/side_button2";
import { getURLandredirect } from "../helper/api";
import "../css/splash2.css";
import PageHead from "../components/Splash/PageHead";

import ytLogo from "../assets/yt-logos.avif";
import apposlash from "../assets/apposlash.gif";

import homeImage from "../assets/footer-space-man.avif";
import "./Loader.css";
import "../css/profile.css";
import UserProfile from "../components/UserProfile";
/* import ChristmasLights from "../components/ChristmasLights"; */
import Footer from "../components/Footer";
import AdsterraAd from "../components/Adsterads";
import G13Ads from "../components/g13ads";
/* import Snowfall from "react-snowfall"; */
/* import tree from "../assets/tree.avif";
import Snowman from "../assets/SnowMan.avif"; */
/* import light from "../assets/Glight.avif"; */

const getUserAgent = () => {
  let agent = navigator.userAgent.toLowerCase();
  let result = "";
  if (agent.includes("android")) {
    result = "android";
  } else if (agent.includes("iphone")) {
    result = "ios";
  } else {
    result = "desktop";
  }
  return result;
};
const Splash = () => {
  const [buttonVisible, setButtonVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [buttonText, setButtonText] = useState("Redirecting in 3");
  const [showCancelButton, setShowCancelButton] = useState(true); // Loader state for UI feedback
  const [state, setState] = useState({
    intentvalue: "",
    original_url: "",
    linkMetadata: {},
    seconds: 3,
    redirectText: "Redirecting in ",
    video_id: "",
    showImage: false,
  });
  const timerIntervalRef = useRef(null);
  const continueButtonRef = useRef(null);
  const { apptype, shorturl } = useParams();

  const updateScreenSize = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isSmallScreen: window.innerWidth <= 655,
    }));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const debouncedResize = setTimeout(() => {
        updateScreenSize();
      }, 200);

      return () => clearTimeout(debouncedResize); // Clear timeout if the resize happens before 200ms
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [updateScreenSize]);

  const startTimer = useCallback((app_intend, click_link) => {
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);

    timerIntervalRef.current = setInterval(() => {
      setState((prevState) => {
        if (prevState.seconds <= 1) {
          clearInterval(timerIntervalRef.current);
          setShowCancelButton(false);
          click_link.setAttribute("href", app_intend);
          const agent = getUserAgent();
          if (agent === "desktop") {
            const newTab = window.open("", "_blank");
            if (newTab) {
              newTab.document.write(
                `
                <html>
                <head>
                <title>Redirecting...</title>
                <body>
                <a id="redirectLink" href="${app_intend}">Click here if not redirected</a>
                <script>
                document.getElementById('redirectLink').click();
                </script>
                <script data-cfasync="false" type="text/javascript" id="clever-core">
 /* <![CDATA[ */
     (function (document, window) {
         var a, c = document.createElement("script"), f = window.frameElement;
 
         c.id = "CleverCoreLoader89618";
         c.src = "https://scripts.cleverwebserver.com/b808f0a1150069f8ab4947f2d536ab0a.js";
 
         c.async = !0;
         c.type = "text/javascript";
         c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
         c.setAttribute("data-callback", "put-your-callback-function-here");
         c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
         c.setAttribute("data-callback-url-view", "put-your-view-macro-here");
         
 
         try {
             a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
         } catch (e) {
             a = !1;
         }
 
         a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
         a.parentNode.insertBefore(c, a);
     })(document, window);
 /* ]]> */
 </script>
                </body>
                </html>
              `
              );
              newTab.document.close();
            }
          }else{
            click_link.click();
          }
          console.log(prevState);
          return {
            ...prevState,
            seconds: 0,
            redirectText: "Redirecting...",
            showImage: true,
          };
        }

        return { ...prevState, seconds: prevState.seconds - 1 };
      });
    }, 1000);

    // Trigger manual click in case automatic click fails
    setTimeout(() => {
      click_link.onclick = (e) => {
        e.preventDefault();
        window.open(app_intend, "_self");
      };
    }, 5000);
  }, []);

  const handleApiDataLoaded = useCallback(() => {
    setLoading(false);
    // Hide loader once data is loaded
  }, []);

  useEffect(() => {
    setLoading(true); // Show loader when API starts fetching
    let app_intend = "";
    const click_link = document.getElementById("abcd");
    getURLandredirect(apptype, shorturl)
      .then((res) => {
        if (!res) return;
        const linkMeta = res.data.metadata || {};
        const videoId = extractVideoId(res.data.originalURL);
        /*  console.log("API Response:", res.data); */
        if (linkMeta) {
          const metadata = {
            title: linkMeta.title || "Get Smart Links with AppOpener",
            image: linkMeta.image || linkMeta.thumbnail || homeImage,
            description:
              linkMeta.description || "Generate Smart Links with AppOpener",
            videoId: linkMeta.videoId,
          };

          /*   console.log("Link Metadata:", metadata); */

          setState((prevState) => ({
            ...prevState,
            linkMetadata: metadata,
            intentvalue: res.data.app_intend,
            original_url: res.data.originalURL,
            video_id: videoId,
          }));
          /* 
          console.log("Intent Value:", res.data.app_intend);
          console.log("Original URL:", res.data.originalURL);
          console.log("Video ID:", videoId); */
        }

        app_intend = res.data.app_intend;

        if (app_intend === "Desktop" || app_intend === "Mobile") {
          app_intend = res.data.originalURL;
        }

        setButtonVisible(true);
      })
      .finally(() => {
        setLoading(false);
        if (app_intend && click_link) {
          startTimer(app_intend, click_link);
        }
      });
  }, [apptype, shorturl, startTimer]);

  const extractVideoId = (url) => {
    const urlObj = new URL(url);
    if (url.includes("youtu.be")) {
      return urlObj.pathname.substr(1);
    }
    if (url.includes("live") || url.includes("shorts")) {
      return urlObj.pathname.split("/")[2];
    }
    return urlObj.searchParams.get("v");
  };
  const handleCancel = () => {
    clearInterval(timerIntervalRef.current);
    setButtonText("Press to Open");
    setShowCancelButton(false);
  };

  const handleButtonClick = () => {
    if (buttonText === "Press to Open") {
      const click_link = document.getElementById("abcd");
      click_link.click();
    }
  };

  // Memoize computed values to prevent unnecessary recalculations
  const redirectContent = useMemo(() => {
    if (buttonText === "Press to Open") {
      return (
        <>
          {" "}
          <div className="flex flex-row">
            <img
              src={ytLogo}
              alt="App Logo"
              style={{ width: "22px", height: "22px", marginRight: "5px" }}
            />
            Press to Open
          </div>
        </>
      );
    }

    return state.showImage ? (
      <div className="flex flex-row">
        <img
          src={ytLogo}
          alt="App Logo"
          style={{ width: "22px", height: "22px", marginRight: "0px" }}
        />{" "}
        <div>&nbsp;Press to Open</div>
      </div>
    ) : (
      state.redirectText + ` ${state.seconds}`
    );
  }, [buttonText, state.showImage, state.redirectText, state.seconds]);
  return (
    <>
       <AdsterraAd/>

      {loading}
      {state.linkMetadata && <PageHead metadata={state.linkMetadata} />}
      <div className="bg-white pb-8">
        {state.video_id && (
          <UserProfile
            video_id={state.video_id}
            onApiDataLoaded={handleApiDataLoaded}
            onCancelRedirect={handleCancel}
          />
        )}

        {/*         <a href="https://apposlash.com/">
        <img
          src={apposlash}
          alt="Animated Banner"
          className="w-full h-16 object-cover mb-4"
        />
        </a> */}

        <a
          className="continueButton stickyButton"
          id="abcd"
          ref={continueButtonRef}
        >
          <button
            style={{ color: "white", fontWeight: "600" }}
            onClick={handleButtonClick}
          >
            <span style={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
              {redirectContent}
            </span>
          </button>
        </a>
        {/* <img src={light} alt="" style={{width: "100%", position: "absolute", pointerEvents: "none"}}  /> */}

        {buttonVisible && showCancelButton && (
          <button
            style={{
              color: "white",
              fontWeight: "600",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              margin: "10px auto 0",
            }}
            onClick={handleCancel}
            className="cancel"
            id="cancel"
          >
            Cancel
          </button>
        )}

        {/*  <div 
    className="flex flex-row gap-0 mt-3 justify-center"
    onClick={() => window.location.href = "https://secret-santa.loginskip.com/"} 
    style={{
        border: "5px solid #ff0000", 
        boxShadow: "0 7px 16px rgba(0, 0, 0, 0.5)", 
        borderRadius: "10px", 
        background: "linear-gradient(to bottom,rgb(246 51 51), rgb(181 173 173))", 
        cursor: "pointer", 
        padding: "3px", 
        margin: "10px",
        marginBottom: "0px"
    }}
>
    <img src={Snowman} alt="" style={{ width: "120px", marginRight: "-9px" }} />
    <img src={tree} alt="" style={{ width: "120px" }} />
</div>
<div className="text-uppercase font-bold " style={{
  display: "flex",
      justifyContent: "center",
      fontSize: "17px",
    }} >Crafted for the love of your pookies</div> */}
        <div className="flex pb-5">
          <div
            className="Glass w-[100%] lg:w-[40%] md:w-[40%]"
            style={{ margin: "20px auto", textAlign: "center" }}
          >
            {state.linkMetadata.image && (
              <div className="thumb">
                {state.linkMetadata.videoId === undefined ||
                state.linkMetadata.videoId === "" ||
                state.linkMetadata.videoId === null ? (
                  <iframe
                    width="500"
                    height="315"
                    src={`https://www.youtube.com/embed/${state.video_id}`}
                  ></iframe>
                ) : (
                  <iframe
                    width="500"
                    height="315"
                    src={`https://www.youtube.com/embed/${state.linkMetadata.videoId}`}
                  ></iframe>
                )}
              </div>
            )}

            {/*  <div className="thumb">
           <iframe
                  width="500"
                  height="315"
                  src={`https://www.youtube.com/embed/${state.video_id}`}
                ></iframe>
           </div>  */}

            <div style={{ color: "white", padding: "15px", fontWeight: "700" }}>
              {state.linkMetadata.title}
            </div>
          </div>
        </div>

        {/*         <a href="https://apposlash.com/">
          <img
             src={apposlash}
             alt="Animated Banner"
            className="w-full h-16 object-cover mb-4"
          />
        </a> */}
      </div>
      <BottomNav />
      <Float />
      <Floattwo />
      {/* <CrazyShop />    */}
      <div className="mt-[-70px] md:mt-[-20px] lg:mt-[-20px]">
        <Footer />
      </div>
    </>
  );
};

export default Splash;
